// removed by extract-text-webpack-plugin
module.exports = {"hidden":"src-pages-program----program-module---hidden---3v4i8","h2":"src-pages-program----program-module---h2---1PKbM","tabs":"src-pages-program----program-module---tabs---1Rpvr","sectionBreak":"src-pages-program----program-module---sectionBreak---yq7kk","bullets":"src-pages-program----program-module---bullets---1Hn9c"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/program/program.module.scss
// module id = 169
// module chunks = 152909308826437